import { getCountry } from '@iwIntlProvider/CountryProvider';
import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import {
    getOpenBankingStatus,
    OpenBankingStatus
} from './getOpenBankingStatus';
import { useStateKey } from '../../iwQueryClient/useStateKey';

export const useGetOpenBankingStatus = (): OpenBankingStatus => {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['online_accounts', stateKey],
        queryFn: () => fetchGetOnlineAccount({ stateKey }),
        suspense: true,
        useErrorBoundary: (_error, query) => !query.state.data
    });

    const status = getOpenBankingStatus(data!.data);

    if (status === 'expiring' && getCountry() !== 'UK') {
        return 'connected';
    }

    return status;
};
